import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

import { SnappingSettingsTooltip } from './SnappingSettingsTooltip';

export function SnappingSettingsCheckbox(props: {
  label: string;
  tooltip: string;
  disabled?: boolean;
  checked: boolean;
  onChange(): void;
}) {
  return (
    <SnappingSettingsTooltip title={props.tooltip}>
      <FormControlLabel
        disabled={props.disabled}
        label={props.label}
        control={<Checkbox size="small" disabled={props.disabled} checked={props.checked} onChange={props.onChange} />}
      />
    </SnappingSettingsTooltip>
  );
}
